<app-side-menu>
  <div class="stock-view-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <button 
                type="button"
                class="btn btn-outline-secondary me-3"
                (click)="back()">
                <i class="fas fa-arrow-left me-2"></i>
                Voltar
              </button>
              <div>
                              <h1 class="page-title">
                <i class="fas fa-eye me-3"></i>
                Detalhes do Estoque
              </h1>
              <p class="page-subtitle">Visualize as informações completas do estoque</p>
              </div>
            </div>
            <div class="btn-group" *ngIf="stock">
              <button
                *appHasPermission="'Warehouses.Manage'"
                type="button"
                class="btn btn-warning me-2"
                (click)="manageWarehouse()">
                <i class="fas fa-warehouse me-2"></i>
                Gerenciar Almoxarifado
              </button>
              <button
                *appHasPermission="'Inventory.Edit'"
                type="button"
                class="btn btn-primary"
                (click)="edit()">
                <i class="fas fa-edit me-2"></i>
                Editar Estoque
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
      <p class="mt-3 text-muted">Carregando detalhes do estoque...</p>
    </div>

    <!-- Detalhes do Estoque -->
    <div *ngIf="!isLoading && stock" class="row">
      <div class="col-12">
        <div class="stock-details-card">
          <!-- Informações Básicas -->
          <div class="card-section">
            <h3 class="section-title">
              <i class="fas fa-info-circle me-2"></i>
              Informações Básicas
            </h3>
            
            <div class="row g-3">
              <div class="col-md-3">
                <div class="info-item">
                  <label class="info-label">Código</label>
                  <div class="info-value code-value">{{ stock.code }}</div>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="info-item">
                  <label class="info-label">Nome</label>
                  <div class="info-value">{{ stock.name }}</div>
                </div>
              </div>
              
              <div class="col-md-3">
                <div class="info-item">
                  <label class="info-label">Status</label>
                  <div class="info-value">
                    <span [class]="getStatusBadgeClass(stock.status)">
                      {{ stock.status }}
                    </span>
                  </div>
                </div>
              </div>
              
              <div class="col-md-4">
                <div class="info-item">
                  <label class="info-label">Tipo</label>
                  <div class="info-value">
                    <span class="badge bg-info">{{ stock.type }}</span>
                  </div>
                </div>
              </div>
              
              <div class="col-md-4">
                <div class="info-item">
                  <label class="info-label">Categoria</label>
                  <div class="info-value">
                    <span *ngIf="stock.category" class="badge bg-secondary">{{ stock.category }}</span>
                    <span *ngIf="!stock.category" class="text-muted">-</span>
                  </div>
                </div>
              </div>
              
              <div class="col-md-4">
                <div class="info-item">
                  <label class="info-label">Grupo de Estoque</label>
                  <div class="info-value">
                    <span *ngIf="stock.stockGroup" class="badge bg-primary">{{ stock.stockGroup }}</span>
                    <span *ngIf="!stock.stockGroup" class="text-muted">-</span>
                  </div>
                </div>
              </div>
              
              <div class="col-12" *ngIf="stock.description">
                <div class="info-item">
                  <label class="info-label">Descrição</label>
                  <div class="info-value">{{ stock.description }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Localização e Quantidades -->
          <div class="card-section">
            <h3 class="section-title">
              <i class="fas fa-map-marker-alt me-2"></i>
              Localização e Quantidades
            </h3>
            
            <div class="row g-3">
              <div class="col-md-4">
                <div class="info-item">
                  <label class="info-label">Almoxarifado</label>
                  <div class="info-value">
                    <span *ngIf="stock.warehouseName" class="text-primary">{{ stock.warehouseName }}</span>
                    <span *ngIf="!stock.warehouseName" class="text-muted">-</span>
                  </div>
                </div>
              </div>
              
              <div class="col-md-4">
                <div class="info-item">
                  <label class="info-label">Localização</label>
                  <div class="info-value">
                    <span *ngIf="stock.location">{{ stock.location }}</span>
                    <span *ngIf="!stock.location" class="text-muted">-</span>
                  </div>
                </div>
              </div>
              
              <div class="col-md-4">
                <div class="info-item">
                  <label class="info-label">Unidade</label>
                  <div class="info-value">
                    <span *ngIf="stock.unit">{{ stock.unit }}</span>
                    <span *ngIf="!stock.unit" class="text-muted">-</span>
                  </div>
                </div>
              </div>
              
              <div class="col-md-3">
                <div class="info-item">
                  <label class="info-label">Quantidade Atual</label>
                  <div class="info-value quantity-value" [class]="getQuantityStatusClass(stock)">
                    {{ stock.currentQuantity | number:'1.2-2' }}
                    <span *ngIf="stock.unit" class="text-muted">{{ stock.unit }}</span>
                  </div>
                  <small [class]="getQuantityStatusClass(stock)">
                    {{ getQuantityStatusText(stock) }}
                  </small>
                </div>
              </div>
              
              <div class="col-md-3">
                <div class="info-item">
                </div>
              </div>
              
              <div class="col-md-3">
                <div class="info-item">
                  <label class="info-label">Quantidade Disponível</label>
                  <div class="info-value">
                    {{ stock.availableQuantity | number:'1.2-2' }}
                    <span *ngIf="stock.unit" class="text-muted">{{ stock.unit }}</span>
                  </div>
                </div>
              </div>
              
              <div class="col-md-3">
                <div class="info-item">
                  <label class="info-label">Quantidade Mínima</label>
                  <div class="info-value">
                    <span *ngIf="stock.minimumQuantity">{{ stock.minimumQuantity | number:'1.2-2' }}</span>
                    <span *ngIf="!stock.minimumQuantity" class="text-muted">-</span>
                    <span *ngIf="stock.unit && stock.minimumQuantity" class="text-muted">{{ stock.unit }}</span>
                  </div>
                </div>
              </div>
              
              <div class="col-md-3">
                <div class="info-item">
                  <label class="info-label">Quantidade Máxima</label>
                  <div class="info-value">
                    <span *ngIf="stock.maximumQuantity">{{ stock.maximumQuantity | number:'1.2-2' }}</span>
                    <span *ngIf="!stock.maximumQuantity" class="text-muted">-</span>
                    <span *ngIf="stock.unit && stock.maximumQuantity" class="text-muted">{{ stock.unit }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Valores Financeiros -->
          <div class="card-section">
            <h3 class="section-title">
              <i class="fas fa-dollar-sign me-2"></i>
              Valores Financeiros
            </h3>
            
            <div class="row g-3">
              <div class="col-md-4">
                <div class="info-item">
                  <label class="info-label">Custo Unitário</label>
                  <div class="info-value">
                    {{ formatCurrency(stock.unitCost, stock.currencyCode) }}
                  </div>
                </div>
              </div>
              
              <div class="col-md-4">
                <div class="info-item">
                  <label class="info-label">Valor Total</label>
                  <div class="info-value">
                    {{ formatCurrency(stock.totalValue, stock.currencyCode) }}
                  </div>
                </div>
              </div>
              
              <div class="col-md-4">
                <div class="info-item">
                  <label class="info-label">Moeda</label>
                  <div class="info-value">
                    <span *ngIf="stock.currencyCode" class="badge bg-success">{{ stock.currencyCode }}</span>
                    <span *ngIf="!stock.currencyCode" class="text-muted">-</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Responsável e Configurações -->
          <div class="card-section">
            <h3 class="section-title">
              <i class="fas fa-user me-2"></i>
              Responsável e Configurações
            </h3>
            
            <div class="row g-3">
              <div class="col-md-6">
                <div class="info-item">
                  <label class="info-label">Pessoa Responsável</label>
                  <div class="info-value">
                    <span *ngIf="stock.responsiblePerson">{{ stock.responsiblePerson }}</span>
                    <span *ngIf="!stock.responsiblePerson" class="text-muted">-</span>
                  </div>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="info-item">
                  <label class="info-label">Email do Responsável</label>
                  <div class="info-value">
                    <span *ngIf="stock.responsibleEmail">{{ stock.responsibleEmail }}</span>
                    <span *ngIf="!stock.responsibleEmail" class="text-muted">-</span>
                  </div>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="info-item">
                  <label class="info-label">Departamento</label>
                  <div class="info-value">
                    <span *ngIf="stock.department">{{ stock.department }}</span>
                    <span *ngIf="!stock.department" class="text-muted">-</span>
                  </div>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="info-item">
                  <label class="info-label">Filial</label>
                  <div class="info-value">
                    <span *ngIf="stock.branch">{{ stock.branch }}</span>
                    <span *ngIf="!stock.branch" class="text-muted">-</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Configurações de Controle -->
          <div class="card-section">
            <h3 class="section-title">
              <i class="fas fa-cogs me-2"></i>
              Configurações de Controle
            </h3>
            
            <div class="row g-3">
              <div class="col-md-3">
                <div class="info-item">
                  <label class="info-label">Ativo</label>
                  <div class="info-value">
                    <span [class]="stock.isActive ? 'badge bg-success' : 'badge bg-danger'">
                      {{ stock.isActive ? 'Sim' : 'Não' }}
                    </span>
                  </div>
                </div>
              </div>
              
              <div class="col-md-3">
                <div class="info-item">
                  <label class="info-label">Permitir Estoque Negativo</label>
                  <div class="info-value">
                    <span [class]="stock.allowsNegativeStock ? 'badge bg-warning' : 'badge bg-info'">
                      {{ stock.allowsNegativeStock ? 'Sim' : 'Não' }}
                    </span>
                  </div>
                </div>
              </div>
              
              <div class="col-md-3">
                <div class="info-item">
                  <label class="info-label">Rastrear Lote</label>
                  <div class="info-value">
                    <span [class]="stock.trackBatch ? 'badge bg-success' : 'badge bg-secondary'">
                      {{ stock.trackBatch ? 'Sim' : 'Não' }}
                    </span>
                  </div>
                </div>
              </div>
              
              <div class="col-md-3">
                <div class="info-item">
                  <label class="info-label">Rastrear Validade</label>
                  <div class="info-value">
                    <span [class]="stock.trackExpiration ? 'badge bg-success' : 'badge bg-secondary'">
                      {{ stock.trackExpiration ? 'Sim' : 'Não' }}
                    </span>
                  </div>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="info-item">
                  <label class="info-label">Último Inventário</label>
                  <div class="info-value">
                    {{ formatDate(stock.lastInventoryDate) }}
                  </div>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="info-item">
                  <label class="info-label">Próximo Inventário</label>
                  <div class="info-value">
                    {{ formatDate(stock.nextInventoryDate) }}
                  </div>
                </div>
              </div>
              
              <div class="col-12" *ngIf="stock.notes">
                <div class="info-item">
                  <label class="info-label">Observações</label>
                  <div class="info-value">{{ stock.notes }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mensagem quando não há estoque -->
    <div *ngIf="!isLoading && !stock" class="text-center py-5">
      <div class="empty-state">
        <i class="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
                        <h5 class="text-muted">Estoque não encontrado</h5>
                <p class="text-muted">O estoque solicitado não foi encontrado ou foi removido.</p>
        <button 
          type="button"
          class="btn btn-primary"
          (click)="back()">
          <i class="fas fa-arrow-left me-2"></i>
          Voltar para Lista
        </button>
      </div>
    </div>
  </div>

  <!-- Modal de Gerenciamento de Almoxarifado -->
  <app-stock-warehouse-modal
    [stock]="stock"
    [isVisible]="showWarehouseModal"
    (close)="closeWarehouseModal()"
    (success)="onWarehouseOperationSuccess()">
  </app-stock-warehouse-modal>
</app-side-menu>
